import React, { useState } from 'react';
import { UploadAreaContainer, UploadIcon } from './styles';
import { RcFile } from 'antd/lib/upload/interface';
import { Button } from '@gerdau/hefesto';
import { Chips } from '@gerdau/hefesto-mais-web';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { useDispatch } from 'react-redux';
import { getTaggingInformationScreen } from '../../../utils/Tagging';
import { camelize, formatTaggingString } from '../../../utils/formatStrings';

interface IUploadAreaProps {
  loading: boolean;
  disabled: boolean;
  onFileListChange(files: RcFile[]): void;
  acceptedFiles: string[];
  acceptMultipleFiles: boolean;
  title?: string;
  subtitle?: string;
  screen?: string;
  hideChips?: boolean;
}

interface ChipsProps {
  id: string;
  label: string;
}

const UploadArea: React.FC<IUploadAreaProps> = ({
  loading,
  disabled,
  acceptedFiles,
  acceptMultipleFiles,
  onFileListChange,
  title,
  subtitle,
  screen,
  hideChips = false
}) => {
  const [uploadedFiles, setUploadedFiles] = useState<RcFile[]>([]);
  const [chipsUploadedFiles, setChipsUploadedFiles] = useState<ChipsProps[]>(
    []
  );
  const uploadSubtitle = subtitle
    ? subtitle
    : 'Clique ou arraste o arquivo para esta área';

  const dispatch = useDispatch();

  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    screen ?? document.location.pathname,
    true
  );

  const addFile = (files: RcFile[]) => {
    const newFileList = acceptMultipleFiles ? [...files] : [files[0]];

    const newchipsUploadedFiles: ChipsProps[] = newFileList.map(
      (file: RcFile) => ({
        id: file.uid,
        label: file.name
      })
    );

    setChipsUploadedFiles(newchipsUploadedFiles);
    setUploadedFiles(newFileList);
    onFileListChange(newFileList);
  };

  const onRemoveChip = (newChipsList: ChipsProps[]) => {
    const newFileList = uploadedFiles.filter((uf) =>
      newChipsList.find((chip) => chip.id === uf.uid)
    );
    setChipsUploadedFiles(newChipsList);
    setUploadedFiles(newFileList);
  };

  return (
    <>
      <UploadAreaContainer
        fileList={uploadedFiles}
        multiple={acceptMultipleFiles}
        showUploadList={false}
        beforeUpload={(_file: RcFile, fileList: RcFile[]) => {
          addFile(fileList);
          return false;
        }}
        accept={acceptedFiles.join(',')}
        disabled={disabled}
      >
        <div>
          <Button
            name="addUploadFile"
            variant="secondary"
            disabled={disabled}
            icon={<UploadIcon />}
            loading={loading}
            onClick={() => {
              dispatch(
                sendTagging({
                  screenName,
                  event: 'click',
                  itemName: `button:${formatTaggingString(
                    title ?? 'Adicionar Arquivos'
                  )}`,
                  itemDescription: `${itemDescription}_${camelize(
                    title ?? 'Adicionar Arquivos'
                  )}`
                })
              );
            }}
          >
            {title ?? 'Adicionar Arquivos'}
          </Button>
          <span>{uploadSubtitle}</span>
        </div>
      </UploadAreaContainer>

      {!hideChips && (
        <Chips
          type="input"
          chips={chipsUploadedFiles}
          updateChips={onRemoveChip}
        />
      )}
    </>
  );
};

export default UploadArea;
